import { ExpressionRule } from "./ExpressionRule";
import { ExpressionValue } from "./ExpressionValue";
import { IBaseExpressionElement } from "./IBaseExpressionElement";
import { ExpressionValueType } from "./ExpressionValueType";
import { ExpressionContext } from "./ExpressionContext";
import { ITestingContext } from "../Common/Testing/ITestingContext";
import { ExecutionData } from "../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../Common/AppGlueAny";

// this one should not be registered as it cannot be added
export class RootExpression extends ExpressionRule {
    readonly __type: string = "__RootExpression";

    expressionRoot: ExpressionValue;
    readonly canSelect: boolean = false;

    constructor() {
        super();
        this.expressionRoot = new ExpressionValue();
        this.expressionRoot.valueType = ExpressionValueType.UNSET;
    }

    getExpressionValues(): ExpressionValue[] {
        return [this.expressionRoot];
    }

    setExpressionContext(selection: ExpressionContext, owner: IBaseExpressionElement): void {
        super.setExpressionContext(selection, owner);
        this.expressionRoot.setExpressionContext(selection, this);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        if (!this.expressionRoot) return undefined;

        return this.expressionRoot.evaluate(data, testContext);
    }
}
